import React from 'react';
import Shape from '@active-channel/images/badges/badge-shapes/badge-shape-price.svg';
import { t } from '@utils/i18n';
import PropTypes from 'prop-types';
import './styles/styles.scss';

const BadgePrice = (props) => {
  const { badgePriceInput, badgePromoType, style } = props;

  let priceLabelTop = '';
  let priceText = badgePriceInput;
  let priceLabelBottom = '';

  switch (badgePromoType) {
    case 'free':
      priceText = t('comp.bannerbadge.label.free');
      break;
    case 'nowonly':
      priceLabelTop = t('comp.bannerbadge.label.nowonly');
      break;
    case 'whilestockslast':
      priceText = t('comp.bannerbadge.label.whilestocklasts');
      break;
    case 'uptoxpctoff':
      priceLabelTop = t('comp.bannerbadge.label.top.uptoxpctoff');
      priceText = `${badgePriceInput}%`;
      priceLabelBottom = t('comp.bannerbadge.label.bottom.uptoxpctoff');
      break;
    case 'buyxgetxfree': // 1+1 gratis
      priceLabelBottom = t('comp.bannerbadge.label.bottom.buyxgetxfree');
      break;
    case 'xdiscount':
      priceLabelBottom = t('comp.bannerbadge.label.bottom.xdiscount');
      break;
  }

  const badgeClass = badgePromoType ? `badge-price-${badgePromoType}` : '';

  return (
    <div style={style} className={`badge-custom badge-price ${badgeClass}`}>
      <Shape className="badge-shape" />
      <div className="badge-price-content">
        <div className="align">
          {priceLabelTop && (
            <span className="badge-price-label">{priceLabelTop}</span>
          )}
          {priceText && <span className="badge-text">{priceText}</span>}
          {priceLabelBottom && (
            <span className="badge-price-label">{priceLabelBottom}</span>
          )}
        </div>
      </div>
    </div>
  );
};

BadgePrice.propTypes = {
  badgePriceInput: PropTypes.string, // not only price, could also be a percentage
  priceType: PropTypes.string,
  badgePromoType: PropTypes.string,
  priceText: PropTypes.string,
  store: PropTypes.object,
  style: PropTypes.object,
};

export default BadgePrice;
